import { defineMessages } from 'react-intl';

export default defineMessages({
    agentLogin: {
        id: 'sasria.mfa.auth.components.LockLogin.Agent Login',
        defaultMessage: 'Agent Login'
    },
    vendorLogin: {
        id: 'sasria.mfa.auth.components.LockLogin.Vendor Login',
        defaultMessage: 'Vendor Login'
    }
});
